import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/** Horloge / temps — cercle + aiguilles duotone */
export const ClockIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Cadran menthe */}
      <circle cx="12" cy="12" r="9.5" fill="var(--equiply-icon-bg)" fillOpacity="0.45" />
      <circle cx="12" cy="12" r="8.25" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" />
      {/* Aiguilles */}
      <path d="M12 7v5l3.5 2" stroke="var(--equiply-icon-fg)" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" />
      {/* Repère 12h */}
      <circle cx="12" cy="12" r="1" fill="var(--equiply-icon-fg)" />
    </svg>
  ),
);
ClockIcon.displayName = "ClockIcon";
